import React, {useEffect, useState} from "react";
import {Dialog} from "@mui/material";
import {observer} from "mobx-react";
import Settings from "../../../settings.json";
import {useStores} from "../../../Hooks";
import {CustomActions} from "../../Domain/QrCode/CustomActions";
import Utility from "../../../Utility";
import {routes} from "../../../App";
import {projectStore} from "../../../index";
import {ProcedureRequester} from "../../../MobxStores/RequestApi/ProcedureRequester"
import {accessItemTypeEnum} from "../../../serverClientShared/sharedEnums";

const HELP_ARTICLE_URL = "https://helpdesk.frontline.io/portal/en/kb/articles/3-1-uploading-a-digital-twin#Before_you_Begin";

const AppRedirectModal = observer(({isAppRedirectModalOpen, setIsAppRedirectModalOpen}) => {
    const {modalStore, generalStore} = useStores();
    const [link, setLink] = useState('');

    const getLink = async () => {
        try {
            const projectId = projectStore.currentProject?.ProjectIdentifier;
            let deepPath = Utility.buildUrl(routes.DEEP_LINK_FLDT, {
                db: generalStore.workspace,
                projectId,
            });
            const id = await ProcedureRequester.setShortUrl(deepPath, {
                db: generalStore.workspace,
                itemType: accessItemTypeEnum.PROJECT,
                itemId: projectId,
            });
            const shortUrl = `s/${id}`;
            setLink(`frn://${shortUrl}`);
        } catch (error) {
            console.error('Failed to generate deep link:', error);
        }
    };

    useEffect(() => {
        if (!isAppRedirectModalOpen) return;
        getLink();
    }, [isAppRedirectModalOpen])

    const handleClose = () => {
        setIsAppRedirectModalOpen(false);
    };

    const handleOpenApp = () => {
        handleClose();
        modalStore.isSelectDigitalTwinUploadModalOpen = false;
        window.location.href = link;
    };

    const renderTitle = () => (
        <h2 className="text-2xl font-bold text-main-normal mt-2 !mb-8">
            Create Digital Twin
        </h2>
    );

    const renderContent = () => (
        <p className="text-base text-main-normal mb-8 px-4 leading-relaxed">
            {generalStore.translate('digitalTwinCreationIsAvailableOnlyThroughTheApp.') +  ' '}
            <a
                href={HELP_ARTICLE_URL}
                rel="noopener noreferrer"
                target="_blank"
                className="hover:underline !text-[#3382ed]"
            >
                {generalStore.translate('MoreInfo').toLowerCase()}
            </a>
        </p>
    );

    const renderActions = () => {
        const baseClass = 'font-medium text-lg py-2 font-bold rounded-button'
        return (<div className="flex items-center gap-14">
            <CustomActions
                textFirstButton={generalStore.translate('cancel')}
                textSecondButton={generalStore.translate('openApp')}
                classNameFirstButton={`${baseClass} text-blue-500 bg-windowsandmenus-normal min-w-[100px]`}
                classNameSecondButton={`${baseClass} text-white bg-inputfield-normal min-w-[110px]`}
                triggerEvent={handleOpenApp}
                handleClose={handleClose}
            />
        </div>)
    };

    return (
        <Dialog
            open={isAppRedirectModalOpen}
            onClose={handleClose}
            PaperProps={{className: "p-2 !rounded-menu"}}
            slotProps={{
                backdrop: {
                    sx: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }
                }
            }}
        >
            <div className="flex flex-col items-center justify-center p-6 text-center">
                {renderTitle()}
                {renderContent()}
                {renderActions()}
            </div>
        </Dialog>
    );
});

export default AppRedirectModal;